module.exports = __webpack_public_path__ + "img/img_title_2.e55fdb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/img_title_2.svg
// module id = F0/W
// module chunks = 1